/**
 * Formats the time remaining until `date` as a human-friendly, rounded string,
 * e.g. "30 days", "1 day", "5 hours", or "less than an hour".
 *
 * Avoids confusing precision like "719 hours" by rounding to the largest
 * sensible unit (days once the remaining time is at least a day).
 */
export function formatTimeUntilExpiration(
  date: Date,
  now: Date = new Date()
): string {
  const diffMs = date.getTime() - now.getTime();
  const hours = diffMs / (1000 * 60 * 60);

  if (hours < 1) return 'less than an hour';

  if (hours < 24) {
    const roundedHours = Math.round(hours);
    return `${roundedHours} ${roundedHours === 1 ? 'hour' : 'hours'}`;
  }

  const days = Math.round(hours / 24);
  return `${days} ${days === 1 ? 'day' : 'days'}`;
}
